import styled from 'styled-components';
import { textTransform } from 'utils';

export default styled.h2`
  // color: ${({ theme }) => theme.color.accent};
  color: #F39696;
  // font-size: 1.4rem;
  font-size:${({ fontSize }) => fontSize?.navTabs || fontSize?.fontSize?.navTabs};
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: ${textTransform};
`;
